import React from 'react';

// local dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/mail-prescriptions';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsMailPrescriptionWidgetSuccess as MemberDetailsSavingsMailPrescriptionWidgetSuccess } from 'ui/views/widgets/memberDetailsSavingsMailPrescriptionWidget';
 *
 * // render
 * <MemberDetailsSavingsMailPrescriptionWidgetSuccess propName='propValue'/>
 */
const memberDetailsSavingsMailPrescriptionWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-details-savings-mail-prescriptions-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                onActionClick={ props.onActionClick }
                classNameTable={ 'ui-member-details-savings-mail-prescriptions-widget__table'}
                disablePagination={ true }
            />
        </div>
    );
};

// set display name
memberDetailsSavingsMailPrescriptionWidgetSuccess.displayName = 'memberDetailsSavingsMailPrescriptionWidget';

// set default props
memberDetailsSavingsMailPrescriptionWidgetSuccess.defaultProps = {
    requestPayload: {},
};

// prop types
memberDetailsSavingsMailPrescriptionWidgetSuccess.propTypes = {};

// ***********************************************

/**
 * @type {object}
 * @desc A React presentation/dumb view component preloader.
 * @example
 * import { memberDetailsSavingsMailPrescriptionWidgetPreloader as MemberDetailsSavingsMailPrescriptionWidgetPreloader } from 'ui/views/widgets/memberDetailsSavingsMailPrescriptionWidget';
 *
 * // render
 * <memberDetailsSavingsMailPrescriptionWidgetPreloader propName='propValue'/>
 */
const memberDetailsSavingsMailPrescriptionWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-savings-mail-prescription-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-savings-mail-prescription-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsSavingsMailPrescriptionWidgetPreloader.displayName = 'memberDetailsSavingsMailPrescriptionWidgetPreloader';

// set default props
memberDetailsSavingsMailPrescriptionWidgetPreloader.defaultProps = {};

// prop types
memberDetailsSavingsMailPrescriptionWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsMailPrescriptionWidget as MemberDetailsSavingsMailPrescriptionWidget } from 'ui/views/widgets/memberDetailsSavingsMailPrescriptionWidget';
 *
 * // render
 * <memberDetailsSavingsMailPrescriptionWidget propName='propValue'/>
 */
export const memberDetailsSavingsMailPrescriptionWidget = withNetworkState( memberDetailsSavingsMailPrescriptionWidgetPreloader, memberDetailsSavingsMailPrescriptionWidgetSuccess );

